export default __webpack_public_path__ + "images/0e40549b2197ef97ccb1c2e3f0fd72da.svg";